import React, { Component } from 'react';
import './offline-message-view.css';

export default class OfflineMessageView extends Component {
  render() {
    return <div className={`rdp-react-componentoffline-message-view`}>
      <span className="rdp-react-componentoffline-message-view-icon"></span>
      <h1 className="rdp-react-componentoffline-message-view-title">Você está offline!</h1>
      <p className="rdp-react-componentoffline-message-view-description">{this.props.message}</p>
    </div>
  }
}
